import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);
export const supabase = supabaseConfigured ? createClient(supabaseUrl, supabaseAnonKey) : null;
export const IMAGE_BUCKET = "salon-images";

function assertSupabaseConfigured() {
  if (!supabaseConfigured || !supabase) {
    throw new Error("VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set to upload images.");
  }
}

function fileExtension(file) {
  const parts = file.name.split(".");
  if (parts.length > 1) {
    return parts[parts.length - 1].toLowerCase();
  }
  return "jpg";
}

function uniqueSuffix() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

function buildImagePath(prefix, shopId, label, file) {
  const ext = fileExtension(file);
  return `${prefix}/${shopId}/${label}-${uniqueSuffix()}.${ext}`;
}

export function buildShopImagePath(shopId, file) {
  return buildImagePath("shops", shopId, "shop", file);
}

export function buildHairdresserImagePath(shopId, file) {
  return buildImagePath("hairdressers", shopId, "hairdresser", file);
}

export async function uploadImage({ file, path }) {
  assertSupabaseConfigured();
  const { error } = await supabase.storage
    .from(IMAGE_BUCKET)
    .upload(path, file, {
      cacheControl: "3600",
      contentType: file.type || "image/jpeg",
      upsert: true,
    });
  if (error) {
    console.error("Supabase storage upload failed:", error);
    throw new Error("Algo correu mal do nosso lado ao enviar a imagem.");
  }
  const { data } = supabase.storage.from(IMAGE_BUCKET).getPublicUrl(path);
  if (!data?.publicUrl) {
    console.error("Supabase storage public URL missing for path:", path);
    throw new Error("Algo correu mal do nosso lado ao enviar a imagem.");
  }
  return data.publicUrl;
}
